export default "__VITE_ASSET__CxyTRE5j__"